export const WIZARD_EVENT_TYPE = {
    sunglasses: 'Sun',
    eyeglasses: 'Eye',
};
